import { defineStore } from 'pinia'
import { CubeQuery } from '@/models/queryBuilder'


export const querystate = defineStore('queryState', {
    state: () => ({
        queryTable: <CubeQuery>{
            dimensions: [
                'plays.play_key',
                'matches.match_type',
                'matches.day_nighter',
                'matches.country',
                'venues.city',
                'venues.stadium',
                'matches.start_date',
                'plays.timestamp',
                "home_team.name",
                "away_team.name",
                'bowling_team.name',
                'batting_team.name',
                "striker.display_name",
                "non_striker.display_name",
                "bowler.display_name",
                "plays.innings",
                "plays.over",
                "plays.delivery",
                "plays.ball",
                "plays.smooth_xml",
                "plays.bat_arc",
                "plays.swing_arc"],
            order: [['matches.start_date', "desc"], ["plays.play_key", "asc"],],
            measures: ["plays.count"],
            filters: [{ "member": "striker.player_id", "operator": "set" }],
            limit: 100,
            total: true,
            offset: 0
        },
        queryDropdown: <CubeQuery>{
            dimensions: ["striker.display_name", "striker.display_name"],
            order: {},
            measures: ["plays.count"],
            filters: [{ "member": "striker.player_id", "operator": "set" }],
            offset: 0,
        },
        options: {
            dimensions: {
                countOption: [
                    'plays.play_key',
                    'matches.match_type',
                    'matches.day_nighter',
                    'matches.country',
                    'venues.city',
                    'venues.stadium',
                    'matches.start_date',
                    'plays.timestamp',
                    "home_team.name",
                    "away_team.name",
                    'bowling_team.name',
                    'batting_team.name',
                    "striker.display_name",
                    "non_striker.display_name",
                    "bowler.display_name",
                    "plays.innings",
                    "plays.over",
                    "plays.delivery",
                    "plays.ball",
                    "plays.smooth_xml",
                    "plays.bat_arc",
                    "plays.swing_arc"],
                batterOption: ["striker.player_id", "striker.display_name"],
                bowlerOption: ["bowler.player_id", "bowler.display_name"],
                venueOption: ["venues.venue_id", "venues.stadium"],
            },
            filters: {
                countOption: [{ "member": "striker.player_id", "operator": "notEquals", "values": ["0"] }, { "member": "striker.player_id", "operator": "set" }],
                batterOption: [{ "member": "striker.player_id", "operator": "notEquals", "values": ["0"] }, { "member": "striker.player_id", "operator": "set" }],
                bowlerOption: [{ "member": "bowler.player_id", "operator": "notEquals", "values": ["0"] }, { "member": "bowler.player_id", "operator": "set" }],
                venueOption: [{ "member": "venues.venue_id", "operator": "notEquals", "values": ["0"] }, { "member": "venues.venue_id", "operator": "set" }]
            },
        },
        selectedFilters: {
            common: {
                batters: {
                    icon: require('../../assets/batter-logo.svg'),
                    selected: [],
                },
                bowlers: {
                    icon: require('../../assets/bowler-logo.svg'),
                    selected: []
                },
                venues: {
                    icon: require('../../assets/venue-logo.svg'),
                    selected: []
                },
            },
            organisation: {
                series: {
                    selected: []
                },
                league: {
                    selected: []
                },
                team: {
                    selected: []
                },
            },
            location: {
                // hemisphere: {
                //     selected: []
                // },
                country: {
                    selected: []
                },
                venues: {
                    selected: []
                },
                // pitch: {
                //     selected: []
                // },
                // pitchType: {
                //     selected: []
                // },
                // pitchCondition: {
                //     selected: []
                // },
                // boundary: {
                //     selected: []
                // },
            },
            matchSetup: {
                // setting: {
                //     selected: []
                // },
                timeOfDay: {
                    selected: []
                },
            },
            matchDetails: {
                // sessions: {
                //     selected: []
                // },
                // matchResult: {
                //     selected: []
                // },
                // leadership: {
                //     selected: []
                // },
                match_id: {
                    literal: null,
                    selected: []
                },
            },
            player: {
                primaryRole: {
                    selected: []
                },
                age: {
                    selected: []
                },
                birthPlace: {
                    selected: []
                },
            },
            batter: {
                Playerid: {
                    selected: []
                },
                batters: {
                    selected: []
                },
                BatHand: {
                    selected: []
                },
                BowlStyle: {
                    selected: []
                },
                team: {
                    selected: []
                },
                HomeAway: {
                    selected: []
                },
                Country: {
                    selected: []
                },
            },
            bowler: {
                Playerid: {
                    selected: []
                },
                bowlers: {
                    selected: []
                },
                BatHand: {
                    selected: []
                },
                BowlStyle: {
                    selected: []
                },
                team: {
                    selected: []
                },
                HomeAway: {
                    selected: []
                },
                Country: {
                    selected: []
                },
            },
            fielder: {
                nameFielder: {
                    selected: []
                },
                Type: {
                    selected: []
                },
                position: {
                    selected: []
                },
                wicketInvolvement: {
                    selected: []
                },
                error: {
                    selected: []
                },
            },
            play: {
                playID: {
                    selected: []
                },
                Inn: {
                    selected: []
                },
                Over: {
                    selected: []
                },
                Delivery: {
                    selected: []
                },
                Ball: {
                    selected: []
                },
                timeCode: {
                    selected: []
                },
                BowlEnd: {
                    selected: []
                },
                WicketFell: {
                    selected: []
                },
                BreakAfterBall: {
                    selected: []
                },
                shotDirection: {
                    selected: []
                },
                missStumps: {
                    selected: []
                },
            },
            tracking: {
                releaseLine: {
                    selected: []
                },
                releaseHeight: {
                    selected: []
                },
                speed: {
                    selected: []
                },
                bounceLine: {
                    selected: []
                },
                bounceLength: {
                    selected: []
                },
                impactPoint: {
                    selected: []
                },
                stumpsPoint: {
                    selected: []
                },
                batSwingTracking: {
                    selected: []
                },
                batImpactTracking: {
                    selected: []
                },
            },
        }
    }),
    getters: {
        getFilters(state) {
            return state.selectedFilters
        },
        getOptions(state) {
            return state.options
        },
        getDropDownQuery(state) {
            return state.queryDropdown
        },
        getTableQuery(state) {
            return state.queryTable
        }
    },
    actions: {
        setTableQueryLimit(limit: number) {
            this.queryTable.limit = limit
        },
        clearAllSelected(obj: any) {
            for (const key in obj) {
                if (typeof obj[key] === "object" && key != "selected") {
                    this.clearAllSelected(obj[key]);
                } else if (key == "selected") {
                    obj[key] = [];
                }
            }
        },
        getValue(obj: any): any {
            const output = []
            for (const k in obj) {
                if (k === 'selected')
                    if (obj[k] == null || obj[k] == undefined || obj[k].length < 1) {
                        continue;
                    } else {
                        output.push(obj[k])
                    }
                else if (typeof obj[k] === 'object')
                    output.push(...this.getValue(obj[k]))
            }
            return output;
        }
    },
})